module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e379267512"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e380268012"
    }
  }, [_vm._v("So many people have invested time and effort into making this book a success. Thank you Grandma Ginny for your baking inspiration, and to Mom for teaching me the basics of home baking. Thanks go to Brian, Ken, and Mike for offering my first opportunity to write professionally for home bakers, and to Libby for talking me through the process of recipe creation and presentation. None of this would be happening without you."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e381270412"
    }
  }, [_vm._v("Thanks also to Bob and Katrina for seeing me through the process of writing this manuscript. Your patience and guidance are precious and made this possible. Thank you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c62325","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sawy_9781605506579_epub_c23_r1.vue
// module id = 81
// module chunks = 0